// [2026-08-11] ADDED — the `cn` helper every shadcn component expects.
//
// clsx resolves conditional class names; twMerge then removes Tailwind classes that CONFLICT, last
// one winning. Without twMerge, `cn("px-4", "px-6")` emits both and which applies depends on the
// order they happen to sit in the compiled stylesheet — so a caller trying to override a
// component's padding gets a result that is correct in dev and wrong after a rebuild.

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
